import { render, staticRenderFns } from "./entry_chjq.vue?vue&type=template&id=103a24a8&scoped=true"
import script from "./entry_chjq.vue?vue&type=script&lang=js"
export * from "./entry_chjq.vue?vue&type=script&lang=js"
import style0 from "./entry_chjq.vue?vue&type=style&index=0&id=103a24a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103a24a8",
  null
  
)

export default component.exports